export default "__VITE_ASSET__Bjpurhv8__"